import { SquareEnvironment } from '../../../api';

export type SquarePaymentFormData = {
  provider: 'square';
  application_id: string;
  location_id: string;
  environment: SquareEnvironment;
  amount: number;
  tip_amount: number;
  booking_fee_amount?: number;
  currency: string;
  transaction_type: string;
  entity_id: string;
  save_card: boolean;
  customer_email: string;
  customer_given_name: string;
  customer_family_name: string;
  checkout_token: string;
};

export const parseSquarePaymentForm = (value: unknown): SquarePaymentFormData | null => {
  let candidate = value;
  if (typeof candidate === 'string') {
    try {
      candidate = JSON.parse(candidate);
    } catch (e) {
      return null;
    }
  }
  if (
    typeof candidate === 'object' &&
    candidate !== null &&
    (candidate as { provider?: string }).provider === 'square'
  ) {
    return candidate as SquarePaymentFormData;
  }
  return null;
};

// The payment form is a URL for most providers and an object for Square. The checkout state keeps one string.
export const toPaymentUrl = (paymentForm: unknown): string =>
  typeof paymentForm === 'string' ? paymentForm : JSON.stringify(paymentForm);

const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export const formatUsd = (amount: number): string => usdFormatter.format(amount);
